import { render, staticRenderFns } from "./Intents.vue?vue&type=template&id=602b13c4&"
import script from "./Intents.vue?vue&type=script&lang=ts&"
export * from "./Intents.vue?vue&type=script&lang=ts&"
import style0 from "./Intents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports